<div class="contextbar" [ngClass]="{ 'contextbar-open': !contextbarService.isContextbarCollapsed }">
  <div *ngIf="title" class="contextbar-header align-items-center">
      <span class="title">{{ title }}</span>
  </div>
  <qpoint-grid-context-bar-options *ngIf="!hideGridOptions" [title]="gridOptionsSectionTitle"></qpoint-grid-context-bar-options>
  <ng-content></ng-content>
</div>
